import { formatCurrency, formatDate } from "@angular/common";
import { Component, Input } from "@angular/core";
import { FormControl, Validators } from "@angular/forms";

@Component({
  template: "",
})
export class FormControlElement {
  @Input() control!: FormControl;
  @Input() updateOn: "change" | "blur" | "submit" = "change";

  required(): boolean {
    if (this.control) return this.control.hasValidator(Validators.required);
    return false;
  }

  formatDate(value: any) {
    return formatDate(value, "dd/MM/yyyy", "nl-BE");
  }

  formatCurrency(value: any) {
    return formatCurrency(value, "nl-BE", "");
  }
}
